import React from "react";
import {
    useHistory
}
from "react-router-dom";

import "./eva.css";
import evaLogo from "./images/eva_logo.png";
import evaPerson from "./images/eva_person.png";
import banner from "./images/banner.png";

import useEva from "./hooks/useEva";
import EvaHomeCard from "./components/EvaHomeCard";
import EvaHomeCardSkeleton
from "./components/EvaHomeCardSkeleton";

import EvaFooter
from "./components/EvaFooter";

import { FontAwesomeIcon }
from "@fortawesome/react-fontawesome";

import {
    faArrowRight,
    faBuilding,
    faShieldHalved,
    faCompassDrafting,
    faScrewdriverWrench,
    faShieldHeart,
    faLeaf
}
from "@fortawesome/free-solid-svg-icons";



import {
    faMagnifyingGlass,
    faSparkles,
    faCircleQuestion
}
from "@fortawesome/free-solid-svg-icons";


export default function Eva()
{
	
	const {
	    homeItems,
	    loading
	} = useEva();
	
	const history =
	    useHistory();
		
		
	//--------------------------------------------------------
	// Open EVA directory
	//--------------------------------------------------------

	const openDirectory =
	    (item) =>
	    {
			 
	        if (!item ||
	            !item.directoryId)
	        {
	            console.log(
	                "EVA: DIRECTORY ID NOT FOUND",
	                item
	            );

	            return;
	        }


	        history.push(
	            "/evadirectory/"
	            + item.directoryId
	        );
	    };

    return (

        <div style={pageStyle}>

            {/* ------------------------------------------------
                Top navigation
            ------------------------------------------------ */}

            <header style={headerStyle} className="eva-header">

                <img
                    src={evaLogo}
                    alt="EVA"
                    style={logoStyle}
                />

                <div style={headerActionsStyle}>

				<div style={searchStyle}>

				    <FontAwesomeIcon
				        icon={faMagnifyingGlass}
				        style={searchIconStyle}
				    />

				    <span>
				        Search
				    </span>

				</div>

                    <div style={profileStyle}>
                        RB
                    </div>

                </div>

            </header>


            {/* ------------------------------------------------
                Hero
            ------------------------------------------------ */}

            <section style={heroStyle} className="eva-hero">

                {/* Decorative banner */}

                <img
                    src={banner}
                    alt=""
					className="eva-banner"
                    style={bannerStyle}
                />


                {/* Hero text */}

				<div
				    style={heroTextStyle}
				    className="eva-hero-text"
				>
				    <h1 style={heroTitleStyle}>
				        Welcome to{" "}
				        <span style={evaTextStyle}>
				            Eva
				        </span>
				    </h1>

				    <div
				        style={heroSubtitleStyle}
				        className="eva-hero-subtitle"
				    >
				        Intelligent knowledge. Instant answers.
				        Smarter estates.
				    </div>

				    <p
				        style={heroDescriptionStyle}
				        className="eva-hero-description"
				    >
				        Eva brings all of your estate information,
				        documents, scans and systems together in one
				        intelligent assistant — helping you work smarter,
				        solve problems faster and deliver better outcomes.
				    </p>
				</div>


                {/* EVA person */}

                <img
                    src={evaPerson}
                    alt="EVA assistant"
					className="eva-person"
                    style={evaPersonStyle}
                />


                {/* EVA introduction */}

                <div style={evaIntroStyle} className="eva-intro">

                    <div style={evaIntroTitleStyle}>
                        Hello, I'm Eva
                    </div>

                    <div style={evaIntroTextStyle}>
                        Ask me anything about your estate,
                        documents, compliance, assets,
                        maintenance and more.
                    </div>

					<button
					    style={askButtonStyle}
					    onClick={() => history.push("/evamainchat")}
					>
					    How can I help you today?
					</button>

                </div>

            </section>


            {/* ------------------------------------------------
                Content placeholder
            ------------------------------------------------ */}

			<main style={contentStyle}>
			{/*====================================================
			     Featured Workplace Card
			   ====================================================*/}

			   <div
			       className="eva-workplace-card"
			       onClick={() => history.push("/evaworkplace")}
			       role="button"
			       tabIndex={0}
			       onKeyDown={(event) => {
			           if (event.key === "Enter" || event.key === " ") {
			               event.preventDefault();
			               history.push("/evaworkplace");
			           }
			       }}
			   >

			       <div className="eva-workplace-image">
			           <img
			               src="/eva/images/office_scan.jpeg"
			               alt="Your Workplace"
			           />
			       </div>

			       <div className="eva-workplace-content">

			           <div className="eva-workplace-eyebrow">
			               EXPLORE
			           </div>

			           <h2>Your Workplace</h2>

			           <p>
			               Take a virtual tour of your workplace.
			               Explore rooms, assets, documentation
			               and surveys — all powered by Eva.
			           </p>

			       </div>

			       <div className="eva-workplace-action">
			           <FontAwesomeIcon icon={faArrowRight} />
			       </div>

			   </div>
			<div
			    className="eva-card-grid"
			    style={cardGridStyle}
			>
			    {
			        loading
			        ?
			        Array.from(
			            { length: 6 }
			        ).map(
			            (_, index) =>
			            {
			                return (
			                    <EvaHomeCardSkeleton
			                        key={index}
			                    />
			                );
			            }
			        )
			        :
			        homeItems.map(
			            (item) =>
			            {
			                return (
			                    <EvaHomeCard
			                        key={
			                            item.directoryId
			                            ||
			                            item.title
			                        }
			                        item={item}
									clickFunction={
									        openDirectory
									    }
			                    />
			                );
			            }
			        )
			    }
			</div>

			</main>


            {/* ------------------------------------------------
                Footer action
            ------------------------------------------------ */}

            <footer style={footerStyle} className="eva-footer">

                <div style={footerMessageStyle}>
                    <span style={sparkleStyle}>
                        ✦
                    </span>

                    <strong>
                        One assistant. Every answer.
                        Endless possibilities.
                    </strong>
                </div>


				<div style={footerActionsStyle}>

				    <button style={faqButtonStyle}>

				        <FontAwesomeIcon
				            icon={faCircleQuestion}
				        />

				        <span>
				            Visit Our FAQs
				        </span>

				    </button>

					<button
					    style={footerButtonStyle}
					    onClick={() => history.push("/evamainchat")}
					>
					    ✦

					    <span>
					        Ask Eva a Question
					    </span>

					</button>

				</div>

            </footer>
			<EvaFooter />
        </div>
    );
}


//============================================================
// Styles
//============================================================

const pageStyle =
{
    position: "fixed",

    top: 0,
    left: 0,
    right: 0,
    bottom: 0,

    width: "100vw",
    height: "100vh",

	background:
	    "linear-gradient(180deg, #ffffff 0%, #f7f6fb 55%, #f4f3f9 100%)",

    color: "#17213b",

    fontFamily:
        "'Inter', 'Segoe UI', Arial, sans-serif",

    overflowX: "hidden",
    overflowY: "auto",

    zIndex: 1000
};


const headerStyle =
{
    position: "absolute",

    top: 0,
    left: 0,
    right: 0,

    height: "92px",

    padding: "0 clamp(22px, 4vw, 64px)",

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    boxSizing: "border-box",

    zIndex: 20
};

const logoStyle =
{
    width: "clamp(190px, 18vw, 290px)",
    height: "auto",
    objectFit: "contain"
};


const headerActionsStyle =
{
    display: "flex",
    alignItems: "center",
    gap: "16px"
};


const searchStyle =
{
    height: "42px",
    minWidth: "160px",

    padding: "0 20px",

    display: "flex",
    alignItems: "center",
    gap: "10px",

    border:
        "1px solid rgba(94,67,180,0.15)",

    borderRadius: "24px",

    background:
        "rgba(255,255,255,0.72)",

    backdropFilter: "blur(12px)",

    color: "#6d6d82",

    fontSize: "14px"
};


const searchIconStyle =
{
    fontSize: "13px",
    color: "#6844c7"
};


const profileStyle =
{
    width: "42px",

    height: "42px",

    display: "flex",

    alignItems: "center",

    justifyContent: "center",

    borderRadius: "50%",

    background:
        "linear-gradient(135deg, #17151d 0%, #2b2733 55%, #17151d 100%)",

    color: "#ffffff",

    fontSize: "13px",

    fontWeight: 700,

    boxShadow:
        "0 5px 14px rgba(20,16,30,0.18)"
};


//============================================================
// Hero
//============================================================

const heroStyle =
{
    position: "relative",

    width: "100%",

    minHeight: "405px",

    padding:
        "115px clamp(40px, 4vw, 70px) 25px",

    boxSizing: "border-box",

    display: "flex",
    alignItems: "center",

    overflow: "hidden"
};


const bannerStyle =
{
    position: "absolute",

    top: "-80px",
    right: "-30px",

    width: "75%",
    minWidth: "800px",

    height: "auto",

    opacity: 0.55,

    pointerEvents: "none",

    zIndex: 0
};


const heroTextStyle =
{
    position: "relative",

    width: "42%",
    maxWidth: "650px",

    zIndex: 3
};


const heroTitleStyle =
{
    margin: 0,

    fontSize: "clamp(44px, 4vw, 68px)",

    lineHeight: 1.05,

    fontWeight: 300,

    letterSpacing: "-2px",

    whiteSpace: "nowrap",

    color: "#17213b"
};


const evaTextStyle =
{
    fontWeight: 700,

    background:
        "linear-gradient(135deg,#7046d8,#9d55df)",

    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent"
};


const heroSubtitleStyle =
{
    marginTop: "22px",

    fontSize:
        "clamp(16px, 1.4vw, 21px)",

    fontWeight: 600,

    color: "#6546c5"
};


const heroDescriptionStyle =
{
    margin: "18px 0 0 0",

    maxWidth: "650px",

    fontSize:
        "clamp(14px, 1.15vw, 17px)",

    lineHeight: 1.7,

    color: "#62687b"
};


//============================================================
// EVA person
//============================================================

const evaPersonStyle =
{
    position: "absolute",

    bottom: "-15px",
    left: "60%",

    height: "390px",

    objectFit: "contain",

    transform: "translateX(-50%)",

    zIndex: 2
};


const evaIntroStyle =
{
    position: "absolute",

    right: "7%",
    top: "50%",

    width: "230px",

    padding: "22px",

    transform: "translateY(-50%)",

    background:
        "rgba(255,255,255,0.82)",

    backdropFilter: "blur(18px)",

    border:
        "1px solid rgba(112,70,216,0.10)",

    borderRadius: "16px",

    boxShadow:
        "0 18px 45px rgba(79,53,140,0.08)",

    zIndex: 4
};


const evaIntroTitleStyle =
{
    marginBottom: "10px",

    fontSize: "18px",
    fontWeight: 700,

    color: "#6844c7"
};


const evaIntroTextStyle =
{
    fontSize: "14px",
    lineHeight: 1.55,

    color: "#62687b"
};


const askButtonStyle =
{
    marginTop: "14px",

    padding: 0,

    border: 0,
    background: "transparent",

    color: "#6844c7",

    fontSize: "14px",
    fontWeight: 600,

    cursor: "pointer"
};


//============================================================
// Main
//============================================================

const contentStyle =
{
    position: "relative",

    padding:
        "30px clamp(22px, 4vw, 64px) 50px",

    zIndex: 5
};



//============================================================
// Footer
//============================================================

const footerStyle =
{
    margin:
        "0 clamp(22px, 4vw, 64px) 24px",

    padding: "18px 24px",

    display: "flex",

    alignItems: "center",

    justifyContent: "space-between",

    gap: "20px",

    borderRadius: "16px",

	background:
	    "linear-gradient(180deg, #2d2042 0%, #211a2c 55%, #17151d 100%)",

    border:
        "1px solid rgba(255,255,255,0.08)",

    boxShadow:
        "0 12px 32px rgba(20,16,30,0.16)"
};

const footerMessageStyle =
{
    display: "flex",
    alignItems: "center",
    gap: "14px",

    color: "#ffffff",

    fontSize: "15px"
};

const sparkleStyle =
{
    fontSize: "22px",
    color: "#9b75ef"
};


const footerButtonStyle =
{
    padding: "11px 20px",

    border: 0,
    borderRadius: "8px",

    background:
        "linear-gradient(135deg,#7650d7,#6034bf)",

    color: "#ffffff",

    fontWeight: 600,

    cursor: "pointer",

    whiteSpace: "nowrap"
};


const footerActionsStyle =
{
    display: "flex",
    alignItems: "center",
    gap: "12px"
};


const faqButtonStyle =
{
    padding: "11px 18px",

    border:
        "1px solid rgba(255,255,255,0.16)",

    borderRadius: "8px",

    background:
        "rgba(255,255,255,0.08)",

    color: "#ffffff",

    fontWeight: 600,

    cursor: "pointer",

    backdropFilter: "blur(8px)"
};

const cardGridStyle =
{
    width: "100%",

    display: "grid",

    gridTemplateColumns:
        "repeat(3, minmax(0, 1fr))",

    gap: "24px"
};

